export default (text: string): Object => {
    return {
        filePath: '<text>',
        messages: [],
        errorCount: 0,
        warningCount: 0
    };
};
